import React from "react"
import TextLoop from "react-text-loop"

const ProfileSlide = () => {
    const SlideList = [
    {
        textPosition: 'text-left',
        category: '',
        description: '',
        buttonText: '',
        buttonLink: ''
    }
    ]

    return (
        <div className="slider-wrapper">
            {/* Start Single Slide */}
            {SlideList.map((value , index) => (
                <div className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center " key={index}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-sm-12 col-md-6">
                                <div className={`inner ${value.textPosition}`}>
                                    <h1 className="title">
                                    <h2>olá 👋</h2>         
                                    <h1>I'm Bryan Kenneth</h1>
                                    <TextLoop>
                                        <span> CompSci Student</span>
                                        <span> Lifelong Learner.</span>
                                        <span> Mobile Developer</span>
                                        <span> Junior Engineer</span>
                                    </TextLoop>{" "}
                                    </h1>
                                    
                                    {value.description ? <p className="description">{value.description}</p> : ''}
                                    {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                </div>
                            </div>
                            

                        </div>
                    </div>
                </div>
            ))}
            {/* End Single Slide */}
        </div>
    )
}

export default ProfileSlide